import React from "react";
import axiosInstance from "../../api/axiosConfig";

const TableProfesionalesEmpresa = () => {
  const [profesionales, setProfesionales] = React.useState([]);

  const fetchProfesionales = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axiosInstance.get("/api/empresa/profesionales", {
        headers: { Authorization: token },
      });
      setProfesionales(res.data);
    } catch (error) {
      console.error("Error al obtener profesionales:", error);
    }
  };

  React.useEffect(() => {
    fetchProfesionales();
  }, []);

  return (
    <div>
      <h2>Mis Profesionales</h2>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ backgroundColor: "#53676c", color: "white" }}>
            <th style={th}>Nombre</th>
            <th style={th}>Apellido</th>
            <th style={th}>Especialidad</th>
            <th style={th}>Teléfono</th>
            <th style={th}>Email</th>
            <th style={th}>Estado</th>
          </tr>
        </thead>
        <tbody>
          {profesionales.length === 0 ? (
            <tr>
              <td colSpan={6} style={{ textAlign: "center", padding: "1rem" }}>
                No hay profesionales registrados
              </td>
            </tr>
          ) : (
            profesionales.map((prof) => (
              <tr key={prof.id} style={{ borderBottom: "1px solid #ddd" }}>
                <td style={td}>{prof.name}</td>
                <td style={td}>{prof.lastName}</td>
                <td style={td}>{prof.specialty}</td>
                <td style={td}>{prof.phone}</td>
                <td style={td}>{prof.email}</td>
                <td style={td}>{prof.status}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

const th = { padding: "12px 16px", textAlign: "left" };
const td = { padding: "10px 16px" };

export default TableProfesionalesEmpresa;
